type IconProps = {
  color?: string;
  size?: number;
  className?: string;
};

export function UploadIcon({
  color = "currentColor",
  size = 20,
  className,
}: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M6.5 19.5C5.118 19.5 3.93917 19.0206 2.9635 18.0617C1.98783 17.1029 1.5 15.9311 1.5 14.5463C1.5 13.3039 1.89967 12.2113 2.699 11.2683C3.49833 10.3253 4.48967 9.76658 5.673 9.59225C5.9935 8.09742 6.74517 6.875 7.928 5.925C9.11067 4.975 10.468 4.5 12 4.5C13.8107 4.5 15.3467 5.13067 16.608 6.392C17.8693 7.65333 18.5 9.18933 18.5 11V11.5H18.8078C19.8616 11.582 20.7404 12.0058 21.4443 12.7713C22.1481 13.5366 22.5 14.4462 22.5 15.5C22.5 16.6153 22.1154 17.5608 21.3463 18.3365C20.5769 19.1122 19.6346 19.5 18.5193 19.5H13.0577C12.5526 19.5 12.125 19.325 11.775 18.975C11.425 18.625 11.25 18.1974 11.25 17.6923V12.2152L9.4 14.0345L8.34625 12.9905L12 9.3365L15.6538 12.9905L14.6 14.0345L12.75 12.2152V17.6923C12.75 17.7692 12.7821 17.8398 12.8462 17.9038C12.9102 17.9679 12.9808 18 13.0577 18H18.5C19.2 18 19.7917 17.7583 20.275 17.275C20.7583 16.7917 21 16.2 21 15.5C21 14.8 20.7583 14.2083 20.275 13.725C19.7917 13.2417 19.2 13 18.5 13H17V11C17 9.61667 16.5125 8.4375 15.5375 7.4625C14.5625 6.4875 13.3833 6 12 6C10.6167 6 9.4375 6.4875 8.4625 7.4625C7.4875 8.4375 7 9.61667 7 11H6.48075C5.53325 11 4.71625 11.3417 4.02975 12.025C3.34325 12.7083 3 13.5333 3 14.5C3 15.4667 3.34167 16.2917 4.025 16.975C4.70833 17.6583 5.53333 18 6.5 18H9V19.5H6.5Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
